"use client";

import { useState } from "react";

import Image from "next/image";

import cn from "classnames";

import { Button } from "@/components/button/button.component";
import { PlayIcon } from "@/components/icons/play.icon";

export const ProductImagesVideo = ({
  videoUrl,
  imageUrl,
  alt,
  onClick,
}: ProductImagesVideoProps) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handleClick = () => {
    if (onClick) return onClick();
    if (videoUrl) setIsVideoPlaying(true);
  };
  if (isVideoPlaying && videoUrl) {
    return (
      <div
        data-testid="product-images-video"
        className={cn(
          "bg-greyscale-background relative h-full w-full overflow-hidden rounded-xl",
        )}>
        <video
          src={videoUrl}
          className="h-full w-full object-cover"
          data-testid="product-images-video-video"
          controls
          playsInline
          autoPlay
          muted
          title={alt ? `Product video: ${alt}` : "Product video"}
        />
      </div>
    );
  }
  return (
    <div
      data-testid="product-images-video"
      className={cn(
        "bg-greyscale-background relative h-full w-full overflow-hidden rounded-xl",
      )}>
      <Button
        type="button"
        data-testid="product-images-video-play-button"
        className="flex h-full w-full cursor-pointer items-center justify-center text-white"
        onClick={handleClick}
        aria-label="Play product video">
        <Image
          width={170}
          height={170}
          src={imageUrl}
          loading="eager"
          alt={alt || ""}
          className={cn("pointer-events-none h-full w-full object-contain", {
            "object-cover": videoUrl,
          })}
          data-testid="product-images-video-image"
        />
        {videoUrl ? (
          <PlayIcon
            aria-hidden
            data-testid="product-images-video-play-icon"
            width={60}
            height={60}
            className="absolute"
          />
        ) : null}
      </Button>
    </div>
  );
};

export type ProductImagesVideoProps = {
  imageUrl: string;
  alt?: string | null;
  videoUrl?: string;
  index: number;
  onClick?: () => void;
  buttonAccessibleLabel?: string;
};
